import { ajaxService } from '../../common/Services';
import { ApiUtils } from '../../common/api';

import { exportEnums } from '../../common/enums';
import ExportTaskModel from './export-task-model';

const _getExportServer = (interactionStrategyIsPartition) =>
  interactionStrategyIsPartition ? exportEnums.exportServers.HERCULES_2 : exportEnums.exportServers.HERCULES_1;

//for now, the MX experience only allows downloading the participants
const _getExportUrls = (interactionStrategyIsPartition, exportType = exportEnums.exportTypes.PARTICIPANTS) =>
  exportEnums.exportUrls[_getExportServer(interactionStrategyIsPartition)][exportType];

function addExportTask({
  id,
  password,
  zipOptionsEnabled,
  passwordProtectedEnabled,
  interactionStrategyIsPartition,
  exportType,
}) {
  const exportUrls = _getExportUrls(interactionStrategyIsPartition, exportType),
    exportService = interactionStrategyIsPartition ? ajaxService.hercules : ajaxService,
    serverURL = App.globalContext.serverURL;
  return exportService
    .post(exportUrls.addExportUrl, {
      [interactionStrategyIsPartition ? 'campaignObjectId' : 'id']: id,
      password,
      zipOptionsEnabled,
      passwordProtectedEnabled,
      serverURL,
    })
    .then(ApiUtils.validate, ApiUtils.validate)
    .then(ApiUtils.extract1)
    .then((response) => ExportTaskModel.deserialize(response));
}

function fetchLastExport({ id, exportId, typeRef, interactionStrategyIsPartition, exportType }) {
  const exportUrls = _getExportUrls(interactionStrategyIsPartition, exportType),
    exportService = interactionStrategyIsPartition ? ajaxService.hercules : ajaxService;
  return exportService
    .post(exportUrls.lastExportUrl, {
      [interactionStrategyIsPartition ? 'campaignObjectId' : 'id']: id,
      typeRef,
      [interactionStrategyIsPartition ? 'id' : 'exportId']:         exportId,
    })
    .then(ApiUtils.validate, ApiUtils.validate)
    .then(ApiUtils.extract1)
    .then((response) => ExportTaskModel.deserialize(response));
}

export default {
  addExportTask,
  fetchLastExport,
};
